import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { apiClient } from "shared/plugins/http-service";
import { UPLOAD_FILE_API } from "shared/constants/api-endpoint";
import { redirectFileLocalUrl } from "shared/plugins/string-helper";
import { IMAGES_FOLDER_ID } from "shared/constants/google-drive";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";

interface TinyMCEProps {
  pageContent?: string;
  height?: number;
  onChange?: (e: any) => void;
}
export const MceEditor = (props: TinyMCEProps) => {
  const token = useSelector(
    (state: RootState) => state.account.token,
    shallowEqual
  );
  const { pageContent, height, onChange } = props;
  const editorRef = useRef<any>();
  const handleEditorChange = (content: string) => {
    onChange && onChange(content);
  };

  return (
    <React.Fragment>
      <Editor
        ref={editorRef}
        value={pageContent}
        outputFormat="html"
        plugins="code"
        apiKey="5pxmhov97hcxec4gsw88rlylmkvdi6jospcfscfxnf5rzvdr"
        textareaName=""
        init={{
          width: "100%",
          height: height ?? 500,
          menu: {
            file: { title: "File", items: "newdocument" },
            edit: {
              title: "Edit",
              items: "undo redo | cut copy paste pastetext | selectall",
            },
            insert: { title: "Insert", items: "link media | template hr" },
            view: { title: "View", items: "visualaid" },
            format: {
              title: "Format",
              items:
                "bold italic underline strikethrough superscript subscript | formats | removeformat",
            },
            table: {
              title: "Table",
              items: "inserttable tableprops deletetable | cell row column",
            },
            tools: { title: "Tools", items: "spellchecker code" },
          },
          tinydrive_token_provider: function (success: any, failure: any) {
            success({ token: token.accessToken });
            // failure('Could not create a jwt token')
          },
          plugins: [
            "autosave advlist autolink lists link image charmap print preview hr anchor pagebreak codesample",
            "searchreplace visualblocks code fullscreen save contextmenu emoticons template textcolor",
            "insertdatetime media table paste code help wordcount",
            "media imagetools importcss tinydrive paste",
          ],
          statusbar: true,
          toolbar:
            "undo redo | formatselect  | bold italic underline code backcolor  strikethrough | \
                      alignleft aligncenter alignright alignjustify |emoticons | preview | anchor insertfile image link openlink unlink media| spellchecker | fullscreen |   \
                      bullist numlist outdent indent | forecolor backcolor casechange permanentpen formatpainter removeformat | help a11ycheck addcomment showcomments casechange checklist formatpainter pageembed permanentpen table",
          a11y_advanced_options: true,
          file_picker_types: "file image media",
          image_caption: true,
          image_advtab: true,
          icons: "jam",
          resize: true,
          target_list: [
            { title: "None", value: "" },
            { title: "Same page", value: "_self" },
            { title: "New page", value: "_blank" },
            { title: "Parent frame", value: "_parent" },
          ],
          file_picker_callback: (callback: any, value: any, meta: any) => {
            // Provide file and text for the link dialog
            // Provide image and alt text for the image dialog
            var input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            if (meta.filetype === "image") {
              input.click();
              input.onchange = () => {
                const formData = new FormData();
                const files = input.files;
                if (files && files.length > 0) {
                  for (var i = 0; i < files.length; i++) {
                    formData.append("uploadedFiles", files[i]);
                  }
                }
                apiClient
                  .postHttp(`${UPLOAD_FILE_API}`, formData, {
                    headers: {
                      "content-type": "multipart/form-data",
                    },
                  })
                  .then((response: any) => {
                    callback(`${response.data[0]}`, {
                      alt: files && files.item.name,
                    });
                  });
              };
            }
            // Provide alternative source and posted for the media dialog
            // if (meta.filetype == 'media') {
            //   callback('movie.mp4', {source2: 'alt.ogg', poster: 'image.jpg'});
            // }
          },
          images_upload_handler: function (
            blobInfo: any,
            success: any,
            failure: any,
            progress: any
          ) {
            let formData: any;
            formData = new FormData();
            formData.append(
              "uploadedFiles",
              blobInfo.blob(),
              blobInfo.filename()
            );
            formData.append("folderId", IMAGES_FOLDER_ID);
            apiClient
              .postHttp(`${UPLOAD_FILE_API}`, formData, {
                headers: {
                  "content-type": "multipart/form-data",
                },
              })
              .then((response: any) => {
                success(redirectFileLocalUrl(response.data[0]));
              });
          },
          convert_urls : false,
          images_upload_url: "",
          image_title: true,
          images_upload_credentials: true,
          paste_data_images: true,
          typeahead_urls: true,
          content_css: "/src/shared/components/tinymce/style_custom.css",
          templates: [
            {
              title: "Khung đỏ",
              description: "Khung đỏ với chữ bên trong.",
              content: '<div class="box-red"><p>Khung đỏ</p></div>',
            },
            {
              title: "Khung tím",
              description: "Khung tím với chữ bên trong.",
              content: '<div class="box-purple"><p>Khung tím</p></div>',
            },
            {
              title: "Khung xanh",
              description: "Khung xanh với chữ bên trong.",
              content: '<div class="box-blue"><p>Khung xanh</p></div>',
            },
            {
              title: "Khung vàng",
              description: "Khung vàng với chữ bên trong.",
              content: '<div class="box-yellow"><p>Khung vàng</p></div>',
            },
            {
              title: "Nền vàng",
              description: "Nền vàng với chữ bên trong.",
              content: '<div class="box-yellow-full"><p>Nền vàng</p></div>',
            },
            {
              title: "Nền xám",
              description: "Nền xám với chữ bên trong.",
              content: '<div class="box-gray-full"><p>Nền xám</p></div>',
            },
            // {title: 'Nút xanh', description: 'Nút xanh.', content: '<a class="btn btn-green" href="#">Tra cứu forex broker</a>'},
            // {title: 'Khung vàng 2 màu', description: 'Khung vàng 2 màu với chữ bên trong.', content: '<div class="box-yellow-2-line"><p>Khung vàng 2 màu</p></div>'},
            // {title: 'Nút vàng', description: 'Nút vàng.', content: '<a class="btn-yellow" data-toggle="modal" href="#registration-modal"><b>Đặt mua ngay</b><span>Để được tặng quà</span></a>'}
          ],
        }}
        onEditorChange={handleEditorChange}
      />
    </React.Fragment>
  );
};
